<template>
    <div :class="`newsletter newsletter--${this.$config.mode}`">
        <form @submit.prevent="onSubmit">
            <div class="formbody">
                <div class="newsletter-subscribe">
                    <div :class="`newsletter-subscribe__message newsletter-subscribe__message--${messageType}`" v-if="message" v-html="message"></div>

                    <div class="input-group" v-else>
                        <div class="input-group__widget widget-text mandatory">
                            <input type="email" name="email" class="text mandatory" placeholder="Enter your e-mail address …" v-model="email" required aria-label="Email address">
                        </div>

                        <div class="input-group-append">
                            <div class="widget-submit">
                                <button type="submit" class="submit" :aria-label="this.$config.mode === 'subscribe' ? 'Subscribe' : 'Unsubscribe'">
                                    <span class="spinner-border spinner-border-sm" aria-hidden="true" v-if="loading"></span>
                                    <span v-else aria-hidden="true">{{ (this.$config.mode === 'subscribe') ? 'Subscribe' : 'Unsubscribe' }}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="widget widget-explanation" v-if="this.$config.mode === 'subscribe'">
                        <p class="mb-0">
                            <span>The controller of your personal data is: <strong>{{ this.$config.shortAddress }}</strong>. </span>
                            <a :href="this.$config.unsubscribePage" v-if="this.$config.unsubscribePage">Click here to unsubscribe</a>
                        </p>
                        <details>
                            <summary>Please read the full disclaimer on data processing, available here</summary>
                            <p class="mb-0">We process the following categories of your personal data: e-mail address. The controller of personal data is {{ this.$config.billingAddress }}, e-mail: <a href="mailto:info@veello.com">info@veello.com</a>. Your personal data will be processed for the purpose of direct marketing (Article 6(1)(f) of the GDPR) by the Controller. The personal data will be kept until such time as you unsubscribe from the newsletter or file an objection to its processing for this purpose. Providing your personal data is voluntary, but necessary for us to send you messages. You have the right of access to, rectification, and erasure of your personal data, and of restriction of the processing thereof. You also have the right to data portability and the right to object to the processing of your personal data. You have the right to lodge a complaint with the President of the Polish Personal Data Protection Office. Personal data will be provided only to our trusted subcontractors, i.e. IT service providers.</p>
                        </details>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { httpClient } from '../../../_helpers/http-client';

    export default {
        data() {
            return {
                loading: false,
                email: '',
                message: '',
                messageType: '',
                showForm: true,
            };
        },
        methods: {
            onSubmit() {
                if (this.$config.mode === 'subscribe') {
                    this.subscribe();
                } else {
                    this.unsubscribe();
                }
            },
            subscribe() {
                this.loading = true;

                httpClient.post(this.$config.subscribeUrl, { email: this.email }).then(response => {
                    let message = 'Thank you for subscribing to our newsletter!';

                    if (response.status === 200) {
                        message += '<br>Please click a link in the confirmation e-mail to complete your subscription.';
                    } else if (response.status === 204) {
                        message += '<p>You are already subscribed to our newsletter.</p>';
                    }

                    this.message = message;
                    this.messageType = 'success';
                    this.showForm = false;
                }).finally(() => this.loading = false);
            },
            unsubscribe() {
                this.loading = true;

                httpClient.delete(this.$config.unsubscribeUrl, { email: this.email }).then(() => {
                    this.message = 'You have successfully unsubscribed from our newsletter. Sorry to see you go!';
                    this.messageType = 'success';
                    this.showForm = false;
                }).finally(() => this.loading = false);
            },
        }
    }
</script>
